import { render, staticRenderFns } from "./FormAddLab400.vue?vue&type=template&id=215efba8"
import script from "./FormAddLab400.vue?vue&type=script&lang=js"
export * from "./FormAddLab400.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports